// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"314":"b52b0e8b","859":"97e5ddc4","991":"d2e052d8"}[chunkId] + ".chunk.js";
};